import React, { Component, PropTypes } from 'react';
import {
  calculateAvgBetSize,
  calculateTotalProfit,
  calculateBetReturn
} from 'utils/calculations';
import { convertCurrency, currencyToText } from 'utils/converters'
import moment from 'moment'
import ReactHighcharts from 'react-highcharts'
import 'css/Analytics.less'
import 'css/dashboardwidget.less'
import { allBookmakers as bookmakers } from 'config'
import ProfitGraph from './ProfitGraph'


export default class Analytics extends Component {

  get generateBookmakerDistributionChart() {
    const bookmakerMap = {}
    this.props.userbets.forEach(bet => {
      let profit = convertCurrency(bet.currency,
                                  this.props.user.currency,
                                  calculateBetReturn(bet.wager, bet.odds, bet.status) - bet.wager,
                                  this.props.currencies)
      bookmakerMap[bet.bookmaker._id] = (bookmakerMap[bet.bookmaker._id] || 0) + profit
    })
    return {
      chart: {
        type: 'column'
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: Object.keys(bookmakerMap).map(b => bookmakers[b]),
      },
      legend: {
        enabled: false
      },
      yAxis: {
        title: {
          text: 'Profit in ' + this.props.user.currency
        }
      },
      series: [{
        name: 'Profits',
        data: Object.keys(bookmakerMap).map(b => Math.round(bookmakerMap[b])),
        colorByPoint: true
      }]
    }
  }

  get generateWeeklyDataChart() {
    const weekMap = new Map()
    const oneYearAgo = moment().subtract(1, 'year')
    const now = moment()
    for (let d = moment().subtract(51, 'week'); d <= now; d = d.add(1, 'week')) {
      weekMap.set(d.isoWeek(), 0)
    }
    this.props.userbets.filter(b => b.createdAt > +oneYearAgo).forEach(bet => {
      let week = moment(bet.createdAt).isoWeek()
      weekMap.set(week, weekMap.get(week) + 1)
    })
    const weekCategories = []
    const weekValues = []
    let foundfirst = false
    weekMap.forEach((v, k) => {
      if (!foundfirst && v > 0)
        foundfirst = true
      if (foundfirst) {
        weekCategories.push(k)
        weekValues.push(v)
      }
    })
    return {
      title: {
        text: ''
      },
      xAxis: {
        name: 'Week number',
        categories: weekCategories,
        title: {
          text: 'Week #'
        }
      },
      yAxis: {
        title: {
          text: '# of bets placed'
        }
      },
      chart: {
        type: 'column'
      },
      series: [{
        data: weekValues,
        name: 'Bets placed'
      }]
    }
  }

  get totalEV() {
    return Math.round(this.props.userbets.map(bet => {
      if (!bet.edge)
        return 0
      return convertCurrency(bet.currency,
                             this.props.user.currency,
                             bet.wager * bet.edge / 100,
                             this.props.currencies)
    }).reduce((a, b) => a + b) * 10) / 10
  }


  get totalTurnover() {
    return this.props.userbets
      .map(bet => convertCurrency(bet.currency, this.props.user.currency, bet.wager, this.props.currencies))
      .reduce((a, b) =>  a + b)
  }

  get averageRoi() {
    return Math.round(calculateTotalProfit(this.props.userbets, this.props.currencies, this.props.user.currency) * 100 / this.totalTurnover * 10) / 10
  }

  render() {
    return (
      <div className='container-fluid analytics'>
        <div className='col-md-4'>
          <AnalyticsWidget
              icon='ionicons ion-ios-star'
              value={currencyToText(
                calculateTotalProfit(this.props.userbets, this.props.currencies, this.props.user.currency),
                this.props.user.currency)}
              label='Total profit'
              color='green'
            />
        </div>
        <div className='col-md-4'>
          <AnalyticsWidget
            icon='ionicons ion-pound'
            value={this.props.userbets.length}
            label='Number of bets'
            color='orange'
          />
        </div>
        <div className='col-md-4'>
          <AnalyticsWidget
            icon='ionicons ion-stats-bars'
            value={this.averageRoi + ' %'}
            label='Average ROI'
            color='blue'
          />
        </div>
        <div className='col-md-4'>
          <AnalyticsWidget
            icon='ionicons ion-card'
            value={currencyToText(
              this.totalEV,
              this.props.user.currency)}
            label='Total expected value'
            color='lightblue'
          />
        </div>
        <div className='col-md-4'>
          <AnalyticsWidget
            icon='ionicons ion-speedometer'
            value={currencyToText(Math.round(this.totalTurnover), this.props.user.currency)}
            label='Total turnover'
            color='darkblue'
          />
        </div>
        <div className='col-md-4'>
          <AnalyticsWidget
            icon='ionicons ion-cash'
            value={currencyToText(
              calculateAvgBetSize(this.props.userbets, this.props.currencies, this.props.user.currency),
              this.props.user.currency)}
            label='Average bet size'
            color='red'
          />
        </div>
        <div className='col-md-12'>
          <div className='panel'>
           <ProfitGraph userbets={this.props.userbets} currencies={this.props.currencies} mainCurrency={this.props.user.currency}/>
          </div>
        </div>
        <div className='col-md-6'>
          <div className='panel'>
            <header className='panel-heading'>Number of bets per week</header>
            <div className='panel-body'>
              <ReactHighcharts config={this.generateWeeklyDataChart} />
            </div>
          </div>
        </div>
        <div className='col-md-6'>
          <div className='panel'>
            <header className='panel-heading'>Profits by bookmaker</header>
            <div className='panel-body'>
              <ReactHighcharts config={this.generateBookmakerDistributionChart} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

class AnalyticsWidget extends Component {

  render() {
    return (
      <div className='analytics-widget clearfix'>
        <span className={'icon ' + this.props.color}>
          <i className={this.props.icon}></i>
        </span>
        <div className='info'>
          <span className='title'>{ this.props.value }</span>
          <span>{ this.props.label }</span>
        </div>
      </div>
    )
  }
}

Analytics.propTypes = {
  userbets: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired
}



/** WEBPACK FOOTER **
 ** ./src/components/analytics/Analytics.js
 **/